import { Col, Collapse, Form, Input, Row } from 'antd';

interface CentralBillingOnlyProps {
  meData: any;
}

const CentralBillingOnly = (props: CentralBillingOnlyProps) => {
  const { meData } = props;

  return (
    <Collapse
      items={[
        {
          key: '1',
          label: '(Optional) Expand for Central Billing Only',
          children: (
            <Row gutter={20}>
              <Col span={24}>
                <Form.Item>
                  <span>
                    The fields below are required only if you are billing for a pharmacy whose NPI
                    and Tax ID are other than what you registered with (your registered NPI is:{' '}
                    {meData.provider_npi} and Tax ID is: {meData.tax_id}. These are also viewable in
                    your account profile by clicking "Edit Profile" above). Leave the fields below
                    blank if you are billing for a pharmacy that has the same NPI and Tax ID as
                    those you registered with.
                  </span>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item name="dispensing_pharmacy_npi" label="Dispensing pharmacy NPI">
                  <Input placeholder="NPI for the pharmacy that will be dispensing this fill (only used if the dispensing pharmacy's NPI is other than your own - otherwise leave blank)" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item name="dispensing_pharmacy_tax_id" label="Dispensing pharmacy Tax ID">
                  <Input placeholder="Tax ID for the pharmacy that will be dispensing this fill (only used if the dispensing pharmacy's Tax ID is other than your own - otherwise leave blank)" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item>
                  <p>Reimbursement for this request is set to be sent to the following address.</p>
                  {meData.reimbursement_address ? (
                    <>
                      <p>{meData.business_name}</p>
                      <p>{meData.reimbursement_address}</p>
                      <p>{meData.reimbursement_address_line2}</p>
                      <p>
                        {meData.reimbursement_address_city}, {meData.reimbursement_address_state}{' '}
                        {meData.reimbursement_address_zip}
                      </p>
                    </>
                  ) : (
                    <>
                      <p>{meData.business_name}</p>
                      <p>{meData.business_address}</p>
                      <p>{meData.business_address_line2}</p>
                      <p>
                        {meData.business_city}, {meData.business_state} {meData.business_zip}
                      </p>
                    </>
                  )}
                </Form.Item>
              </Col>
            </Row>
          ),
        },
      ]}
    />
  );
};

export default CentralBillingOnly;
